import { Injectable } from "@angular/core";
import { GenericRepository } from "./generic-repository";
import { SubflotaModel } from "../services/flota/models/subflota.model";
import { HttpClient } from "@angular/common/http";
import { SsoRepository } from "./sso-repository";
import { catchError, Observable, throwError } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FlotasRepository extends GenericRepository<SubflotaModel> {
  private usuario = this.ssoRepo.getTicket().Usuario.Email;

  public constructor(
    private http: HttpClient,
    private ssoRepo: SsoRepository,
  ) {
    super();
  }
  public fetch(): Observable<SubflotaModel[]> {
    const apiUrl = this.ssoRepo.getTicket().UrlApi;
    const idEmpresa = this.ssoRepo.getTicket().Empresa.IdGestion;
    const url = `${apiUrl}/api/subflotas/${idEmpresa}?include=all`;

    return this.http.get<SubflotaModel[]>(url).pipe(
      catchError((error) => {
        console.error('Error al obtener subflotas:', error);
        return throwError(() => error);
      })
    );
  }
}
